import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [IconComponent],
  imports: [CommonModule],
  exports: [IconComponent]
})
export class IconModule {}
